import { Component, input, output } from '@angular/core';

/**
 * Native-Angular port of the AngularJS `ftStoryHighlight` component
 * (account-v2/.../components/story-highlight/storyHighlight.{component,html}).
 * Used by audiences's Fans-and-Followers panels inside `*ngIf="X.Photos?.length"`
 * branches (not visible at QA-login).
 *
 * v1 template uses `<ft-image>` (custom directive) for profile photo +
 * the `truncate` filter. Native port uses a plain `<img>` element and an
 * inline truncate (200 chars) — the only consumers limit to 200 anyway.
 *
 * Faithful to v1 markup: the outer .ft-panel structure + .ft-bg-image
 * (via [style.background-image]) + .ft-story-info content with conditional
 * quote vs caption.
 */
@Component({
    selector: 'ft-story-highlight',
    templateUrl: './story-highlight.component.html',
    standalone: false
})
export class FtStoryHighlightComponent {
    readonly story = input<any>();
    readonly selected = output<void>();

    protected truncate(s: string | null | undefined, max: number): string {
        if (!s) return '';
        return s.length <= max ? s : s.slice(0, max) + '…';
    }
}
